import React from 'react';

import {HStack, Text, VStack, Badge} from "@chakra-ui/react";
import {format} from "date-fns";

import {useLanguage} from "@/contexts/languageContext";
import {Skeleton} from "@/components";
import stringUtil from "@/utils/stringUtil";
import dateUtil from "@/utils/dateUtil";

export const UserBodySkeleton = ({props}) => {
    return <HStack
        gap="1vw"
        minH="3.5rem"
        overflow="hidden"
        flex={1}
        {...props}
    >
        <VStack align="flex-start" flex={1} overflow="hidden">
            <Skeleton>
                <Text
                    fontWeight="bold"
                    fontSize="md"
                    isTruncated
                >
                    { stringUtil.getRandomString(50, 80) }
                </Text>
            </Skeleton>
        </VStack>
    </HStack>
}

export const UserBody = ({element, ...props}) => {
    return (
        <HStack
            gap="1vw"
            minH="3.5rem"
            color={element.deleted ? "gray.400" : "secondary.500"}
            overflow="hidden"
            {...props}
        >
            <VStack align="flex-start" flex={1} overflow="hidden">
                <Text
                    fontWeight="bold"
                    fontSize="md"
                    isTruncated
                    color={element.deleted ? "gray.400" : "inherit"}
                >
                    {element.firstname} {element.lastname}
                </Text>
            </VStack>
        </HStack>
    );
};

export default UserBody;
